// extracted by mini-css-extract-plugin
export default {"defaultLayout":"Default_defaultLayout__dEc01"};